// calculateOriginalPrice
export function calculateOriginalPrice(price, discountPercentage) {
    return price / (1 - discountPercentage / 100);
  }
  
  // formatUrl
  export function formatUrl(url) {
    return url.toLowerCase()
      .replace(/&/g, "")
      .split(" ")
      .filter(Boolean)
      .join("-");
  }
  
  // averageRating
  export function averageRating(reviews) {
    if (!reviews || reviews.length === 0) {
      return 0; // Return 0 if there are no reviews
    }
  
    // Calculate the sum of all ratings
    const totalRating = reviews.reduce((sum, review) => sum + review.rating, 0);
  
    // Calculate the average rating
    const avgRating = totalRating / reviews.length;
  
    return Number(avgRating.toFixed(0));
  }
  